import { create } from "zustand";

interface BrowserState {
  link: string;
  setLink: (link: string) => void;
}

const useBrowserStore = create<BrowserState>((set) => ({
  link: "",
  setLink: (link: string) => set({ link }),
}));

export default useBrowserStore;
